import {
    FunctionField,
    TextField,
    useLocaleState,
    usePermissions,
    useTranslate,
} from "react-admin";
import { DefaultPagination } from "shared/src/components/DefaultPagination";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaListView } from "shared/src/components/views/RaListView";
import { RaShowButton } from "shared/src/components/buttons/RaShowButton";
import { RaDateField } from "shared/src/components/fields/Ra/RaDateField";
import { Box, Button } from "@mui/material";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { getInspectionCreateLink } from "./getInspectionCreateLink";
import { formatDueInspectionTypes } from "shared/src/utils/formatDueInspectionTypes";

export const SkuInspectionDueList = (props) => {
    const translate = useTranslate();
    const { isLoading, permissions } = usePermissions();
    const [locale] = useLocaleState();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource: "skus", attribute: "read" })) {
        return <AccessRightsError />;
    }

    return (
        <RaListView
            {...props}
            resource="skus"
            actions={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <ToolbarWithHistory export={true} />
                    <Button
                        size="small"
                        href="#/skuInspections/create"
                        startIcon={<FactCheckIcon />}
                    >
                        {translate("equip.recordInspection")}
                    </Button>
                </Box>
            }
            pagination={<DefaultPagination />}
            perPage={50}
            filter={{ inspectionDue: true }}
        >
            <DatagridWithHistory bulkActionButtons={false}>
                <TextField label="equip.labelNumber" source="labelNumber" />
                <TextField
                    label="equip.name"
                    source={`product.name.${locale}`}
                    sortable={false}
                />
                <FunctionField
                    label="equip.inspectionRequired"
                    render={(record) => formatDueInspectionTypes(record, translate)}
                    sortable={false}
                />
                <RaDateField
                    label="equip.lastVdeInspectionAt"
                    source="lastVdeInspectionAt"
                    emptyText={translate("equip.notAvailable")}
                />
                <RaDateField
                    label="equip.lastUvvInspectionAt"
                    source="lastUvvInspectionAt"
                    emptyText={translate("equip.notAvailable")}
                />
                <FunctionField
                    label="equip.actions"
                    render={(record) => (
                        <Button
                            size="small"
                            href={getInspectionCreateLink(record, "skuInspections")}
                            startIcon={<FactCheckIcon />}
                        >
                            {translate("equip.recordInspection")}
                        </Button>
                    )}
                    sortable={false}
                />
                <RaShowButton resource="skus" />
            </DatagridWithHistory>
        </RaListView>
    );
};